import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../../constants-enumerate';

const sdo = {
  namespace: sdoNs.DROPDOWN,
  mutations: {
    /**
     * Init state
     *
     * @return {Object} - new state
     **/
    init() {
      return {};
    },

    /**
     * Add new dd to the state
     *
     * @param {Object} subState - state of the module
     * @param {String} id - id of the dd to add
     * @return {Object} - updated state
     **/
    add(subState, id) {
      return Object.assign({}, subState, {
        [id]: false
      });
    },

    /**
     * Remove dd from the state
     *
     * @param {Object} subState - state of the module
     * @param {String} id - id of the dd to remove
     * @return {Object} - updated state
     **/
    remove(subState, id) {
      const nextsubState = Object.assign({}, subState);
      delete nextsubState[id];
      return nextsubState;
    },

    /**
     * Open dropdown
     *
     * @param {Object} subState - state of the module
     * @param {String} id - id of the dd to open
     * @return {Object} - updated state
     **/
    open(subState, id) {
      const nextModuleMutation = {};
      for (const key in subState) {
        /* istanbul ignore next */
        if (!subState.hasOwnProperty(key)) continue;
        nextModuleMutation[key] = false;
      }
      nextModuleMutation[id] = true;
      return Object.assign({}, subState, nextModuleMutation);
    },

    /**
     * Close dropdown
     *
     * @param {Object} subState - state of the module
     * @param {String} id - id of the dd to close
     * @return {Object} - updated state
     **/
    close(subState, id) {
      return Object.assign({}, subState, {
        [id]: false
      });
    },

    /**
     * Close all dropdowns
     *
     * @param {Object} subState - state of the module
     * @return {Object} - updated state
     **/
    closeAll(subState) {
      const nextModuleMutation = {};
      for (const key in subState) {
        /* istanbul ignore next */
        if (!subState.hasOwnProperty(key)) continue;
        nextModuleMutation[key] = false;
      }
      return Object.assign({}, subState, nextModuleMutation);
    }
  }
};

storeInstance.addState(sdo);

export {
  sdo
};
